import { defineStore } from 'pinia';
import { API_URL, authFetch } from '../api';

export const useIncomeStore = defineStore('incomes', {
  state: () => ({
    incomes: [],
    loading: false,
    error: null,
  }),
  actions: {
    async fetchIncomes() {
      this.loading = true;
      try {
        const response = await authFetch(`${API_URL}/incomes`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        this.incomes = await response.json();
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async addIncome(income) {
      try {
        const transformedIncome = {
          ...income,
          date: income.date ? new Date(income.date).toISOString().split('T')[0] : null
        };
        
        const response = await authFetch(`${API_URL}/incomes`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(transformedIncome),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const newIncome = await response.json();
        this.incomes.push(newIncome);
      } catch (error) {
        this.error = error;
        throw error;
      }
    },
    async deleteIncome(incomeId) {
      try {
        const response = await authFetch(`${API_URL}/incomes/${incomeId}`, {
          method: 'DELETE',
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        this.incomes = this.incomes.filter(income => income.id !== incomeId);
      } catch (error) {
        this.error = error;
        throw error;
      }
    },
    async updateIncome(incomeId, income) {
      try {
        const transformedIncome = {
          ...income,
          date: income.date ? new Date(income.date).toISOString().split('T')[0] : null
        };

        const response = await authFetch(`${API_URL}/incomes/${incomeId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(transformedIncome),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const updatedIncome = await response.json();
        const index = this.incomes.findIndex(i => i.id === incomeId);
        if (index !== -1) {
          this.incomes[index] = updatedIncome;
        }
      } catch (error) {
        this.error = error;
        throw error;
      }
    }
  }
});